import { createReducer, on } from '@ngrx/store';
import {
  EDIT_HEADER_STATE_SUCCESS,
  RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS,
  RETRIEVE_DESTINATARI_BACHECA_SUCCESS,
  RETRIEVE_HEADER_DETAIL_SUCCESS,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
  RETRIEVE_MESSAGGI_BACHECA_SUCCESS,
  RETRIEVE_ID_RECIPIENTS_SUCCESS,
  RETRIEVE_HEADER_LIST_SUCCESS,
  RETRIEVE_LISTA_RETE_TERZA_SUCCESS,
  RETRIEVE_RECIPIENTS_SUCCESS,
  RETRIEVE_REPORT_BACHECA_SUCCESS,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
  RICHIEDI_EXPORT_SUCCESS,
  SAVE_EDIT_HEADER_DETAIL_SUCCESS,
  SAVE_HEADER_DETAIL_SUCCESS,
  SAVE_RECIPIENTS_LIST_SUCCESS,
  VERIFY_RECIPIENTS_LIST_SUCCESS,
  DELETE_EL_BACHECA_SUCCESS,
  EDIT_RECIPIENTS_LIST_SUCCESS,
} from './communication.actions';
import { ICommunicationState } from './communication';
import { ResponseRetrieveRecipients } from '../../interfaces/retrieve-recipients';
import { IDeleteElNoticeboard, ResponseComunicationBoardList } from '../../interfaces/response-comunication-board-list';
import { ResponseReportBoardList } from '../../interfaces/report-comunicazioni-bacheca';
import { IResponseRichiediExport } from '../../interfaces/richiedi-export';
import { IResponseRetrieveHeaderDetail } from '../../interfaces/response-retrieve-header-detail';
import { ResponseMessageBoardList } from '../../interfaces/messaggi-comunicazioni-bacheca';
import { ResponseRecipientsBoardList } from '../../interfaces/destinatari-comunicazioni-bacheca';
import { ResponseSaveDetailComunicationBoardList } from '../../interfaces/response-save-detail-comunication-board-list';
import { ResponseInvioDetailComunicationBoardList } from '../../interfaces/response-invio-detail-comunication-board-list';
import { IResponseReteTerzaList } from '../../interfaces/response-reteterza-list';
import { SaveRecipientsList } from '../../interfaces/response-save-recipients-list';
import { IResponseVerifyRecipientsList } from '../../interfaces/response-verify-recipients-list';
import { ResponseIdRecipients } from '../../interfaces/retrieve-id-recipientslist';

/* INITIAL STATE */
const initialState: ICommunicationState = {
  responseRecipients: null,
  responseBoardList: null,
  responseReportBacheca: null,
  responseRequestExport: null,
  responseRetrieveHeaderDetail: null,
  responseSaveHeaderDetail: null,
  responseMessaggiBacheca: null,
  responseDestinatariBacheca: null,
  responseSaveDetailMessageBacheca: null,
  responseInvioDetailMessageBacheca: null,
  responseReteTerzaList: undefined,
  responseVerifyRecipientsList: null,
  responseSaveRecipientsList: null,
  responseRetrieveIdRecipients: null,
  responseRetrieveHeaderList: null,
  responseEditHeaderState: null,
  responseEditSaveHeaderDetail: null,
  responseDeleteElBacheca: null,
  responseEditRecipientsList: null,
};

const handleResponseRecipients = (
  state: ICommunicationState,
  {
    responseRecipients,
  }: { responseRecipients: ResponseRetrieveRecipients | null }
): ICommunicationState => {
  return {
    ...state,
    responseRecipients,
  };
};

const handleBoardList = (
  state: ICommunicationState,
  {
    responseBoardList,
  }: { responseBoardList: ResponseComunicationBoardList | null }
): ICommunicationState => {
  return {
    ...state,
    responseBoardList,
  };
};

const handleReportBacheca = (
  state: ICommunicationState,
  {
    responseReportBacheca,
  }: { responseReportBacheca: ResponseReportBoardList | null }
): ICommunicationState => {
  return {
    ...state,
    responseReportBacheca,
  };
};

const handleResponseRichiediExport = (
  state: ICommunicationState,
  {
    responseRequestExport,
  }: { responseRequestExport: IResponseRichiediExport | null }
): ICommunicationState => {
  return {
    ...state,
    responseRequestExport,
  };
};

const handleResponseRetrieveHeaederDetail = (
  state: ICommunicationState,
  {
    responseRetrieveHeaderDetail,
  }: { responseRetrieveHeaderDetail: IResponseRetrieveHeaderDetail | null }
): ICommunicationState => {
  return {
    ...state,
    responseRetrieveHeaderDetail,
  };
};

const handleResponseSaveHeaederDetail = (
  state: ICommunicationState,
  {
    responseSaveHeaderDetail,
  }: { responseSaveHeaderDetail: IResponseRetrieveHeaderDetail | null }
): ICommunicationState => {
  return {
    ...state,
    responseSaveHeaderDetail,
  };
};

const handleResponseMessageBoardList = (
  state: ICommunicationState,
  {
    responseMessaggiBacheca,
  }: { responseMessaggiBacheca: ResponseMessageBoardList | null }
): ICommunicationState => {
  return {
    ...state,
    responseMessaggiBacheca,
  };
};

const handleResponseRecipientsBoardList = (
  state: ICommunicationState,
  {
    responseDestinatariBacheca,
  }: { responseDestinatariBacheca: ResponseRecipientsBoardList | null }
): ICommunicationState => {
  return {
    ...state,
    responseDestinatariBacheca,
  };
};

const handleResponseSaveDeatilMessageBoardList = (
  state: ICommunicationState,
  {
    responseSaveDetailMessageBacheca,
  }: {
    responseSaveDetailMessageBacheca: ResponseSaveDetailComunicationBoardList | null;
  }
): ICommunicationState => {
  return {
    ...state,
    responseSaveDetailMessageBacheca,
  };
};

const handleResponseInvioDeatilMessageBoardList = (
  state: ICommunicationState,
  {
    responseInvioDetailMessageBacheca,
  }: {
    responseInvioDetailMessageBacheca: ResponseInvioDetailComunicationBoardList | null;
  }
): ICommunicationState => {
  return {
    ...state,
    responseInvioDetailMessageBacheca,
  };
};

const handleReteTerzaList = (
  state: ICommunicationState,
  { responseReteTerzaList }: { responseReteTerzaList?: IResponseReteTerzaList }
): ICommunicationState => {
  return {
    ...state,
    responseReteTerzaList,
  };
};

const handleRecipientsListVerify = (
  state: ICommunicationState,
  {
    responseVerifyRecipientsList,
  }: { responseVerifyRecipientsList: IResponseVerifyRecipientsList | null }
): ICommunicationState => {
  return {
    ...state,
    responseVerifyRecipientsList,
  };
};

const handleRecipientsListSave = (
  state: ICommunicationState,
  {
    responseSaveRecipientsList,
  }: { responseSaveRecipientsList: SaveRecipientsList | null }
): ICommunicationState => {
  return {
    ...state,
    responseSaveRecipientsList,
  };
};

const handleIdRecipientsList = (
  state: ICommunicationState,
  {
    responseRetrieveIdRecipients,
  }: { responseRetrieveIdRecipients: ResponseIdRecipients | null }
): ICommunicationState => {
  return {
    ...state,
    responseRetrieveIdRecipients,
  };
};

const handleResponseHeaderList = (
  state: ICommunicationState,
  {
    responseRetrieveHeaderList,
  }: { responseRetrieveHeaderList: IResponseRetrieveHeaderDetail | null }
): ICommunicationState => {
  return {
    ...state,
    responseRetrieveHeaderList,
  };
};

const handleEditHeaderState = (
  state: ICommunicationState,
  {
    responseEditHeaderState,
  }: { responseEditHeaderState: IResponseRetrieveHeaderDetail | null }
): ICommunicationState => {
  return {
    ...state,
    responseEditHeaderState,
  };
};

const handleResponseEditSaveHeaederDetail = (
  state: ICommunicationState,
  {
    responseEditSaveHeaderDetail,
  }: { responseEditSaveHeaderDetail: IResponseRetrieveHeaderDetail | null }
): ICommunicationState => {
  return {
    ...state,
    responseEditSaveHeaderDetail,
  };
};

const handleResponseDeleteElBacheca = (
  state: ICommunicationState,
  {
    responseDeleteElBacheca,
  }: { responseDeleteElBacheca: IDeleteElNoticeboard | null }
): ICommunicationState => {
  return {
    ...state,
    responseDeleteElBacheca,
  };
};

const handleResponseEditRecipientsList = (
  state: ICommunicationState,
  {
    responseEditRecipientsList,
  }: { responseEditRecipientsList: SaveRecipientsList | null }
): ICommunicationState => {
  return {
    ...state,
    responseEditRecipientsList,
  };
};

/* REDUCER */
export const communicationReducer = createReducer(
  initialState,
  on(RETRIEVE_RECIPIENTS_SUCCESS, handleResponseRecipients),
  on(RICHIEDI_EXPORT_SUCCESS, handleResponseRichiediExport),
  on(RETRIEVE_LISTA_RETE_TERZA_SUCCESS, handleReteTerzaList),
  on(VERIFY_RECIPIENTS_LIST_SUCCESS, handleRecipientsListVerify),
  on(SAVE_RECIPIENTS_LIST_SUCCESS, handleRecipientsListSave),
  on(RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS, handleBoardList),
  on(RETRIEVE_REPORT_BACHECA_SUCCESS, handleReportBacheca),
  on(RETRIEVE_HEADER_DETAIL_SUCCESS, handleResponseRetrieveHeaederDetail),
  on(SAVE_HEADER_DETAIL_SUCCESS, handleResponseSaveHeaederDetail),
  on(RETRIEVE_MESSAGGI_BACHECA_SUCCESS, handleResponseMessageBoardList),
  on(RETRIEVE_DESTINATARI_BACHECA_SUCCESS, handleResponseRecipientsBoardList),
  on(
    RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
    handleResponseSaveDeatilMessageBoardList
  ),
  on(
    RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
    handleResponseInvioDeatilMessageBoardList
  ),
  on(RETRIEVE_ID_RECIPIENTS_SUCCESS, handleIdRecipientsList),
  on(RETRIEVE_HEADER_LIST_SUCCESS, handleResponseHeaderList),
  on(EDIT_HEADER_STATE_SUCCESS, handleEditHeaderState),
  on(SAVE_EDIT_HEADER_DETAIL_SUCCESS, handleResponseEditSaveHeaederDetail),
  on(DELETE_EL_BACHECA_SUCCESS, handleResponseDeleteElBacheca),
  on(EDIT_RECIPIENTS_LIST_SUCCESS, handleResponseEditRecipientsList),
);
